let httpUrl = 'https://wecom-mapi.aptamil.com.cn';
if (process.env.VUE_APP_ENV === 'development') {
  httpUrl = 'https://mapi-atm-test.linkduoo.com';
}
if (process.env.VUE_APP_ENV === 'production'){
  httpUrl = 'https://wecom-mapi.aptamil.com.cn';
}
if (process.env.VUE_APP_ENV === 'test') {
  httpUrl = 'https://mapi-atm-test.linkduoo.com';
}
const baseUrl = httpUrl;
export default baseUrl;
